var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image 34 (Traced)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7171 2.17804L6.36242 4.09981V6.86942V9.63892L9.54363 9.66785L12.7248 9.69677V18.068V26.4393H11.8493H10.9737V18.8818V11.3244H7.29635H3.61899V18.8818V26.4393H1.8095H0V27.2548V28.0704H13.7755H27.551V27.2548V26.4393H26.6171H25.6832V16.4352V6.43109H24.2823H22.8814V16.4352V26.4393H22.0642H21.247V13.3969C21.247 6.2235 21.2075 0.332393 21.1594 0.305317C21.1113 0.27835 17.7622 1.12109 13.7171 2.17804ZM17.7447 9.47581V11.1069H16.8692H15.9936V9.47581V7.84471H16.8692H17.7447V9.47581ZM8.14588 15.4837L8.1781 17.0876H7.2995H6.42079V15.4517V13.8158L7.26717 13.8478L8.11354 13.8798L8.14588 15.4837ZM17.7447 15.4565V17.0876H16.8692H15.9936V15.529C15.9936 14.6717 16.0286 13.9377 16.0715 13.8979C16.1142 13.858 16.5082 13.8254 16.947 13.8254H17.7447V15.4565ZM8.11354 21.4916V23.1227L7.26717 23.1547L6.42079 23.1866V21.4916V19.7966L7.26717 19.8285L8.11354 19.8605V21.4916ZM17.7447 21.4964V23.1866L16.8983 23.1547L16.052 23.1227L16.0193 21.6056C16.0014 20.7712 16.0129 20.0249 16.0449 19.9473C16.0849 19.8501 16.3587 19.8061 16.9239 19.8061H17.7447V21.4964Z",
    fill: "#4A22D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPlan);
export default __webpack_public_path__ + "static/media/custom-plan.c854d7f5f45ab6f1504e599b10e289ad.svg";
export { ForwardRef as ReactComponent };